module.exports = __webpack_public_path__ + "static/media/trapezoid.0d43929c.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/trapezoid.png
// module id = 145
// module chunks = 0